import { DialogService } from "./dialog.service";
import { MenuService, NavItemsId } from "./menu.service";
import { SnackbarService } from "./snackbar.service";
import { AppService } from "./app.service";
import { AtividadeUsuarioService } from "./atividade-usuario.service";
import { PedidoService } from "./pedido.service";
import { DadosAutenticacao } from "./../models/dadosAutenticacao";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  usuario: DadosAutenticacao;
  logado = false;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private pedidoService: PedidoService,
    private atividadeUsuarioService: AtividadeUsuarioService,
    private appService: AppService,
    private snackbarService: SnackbarService,
    private menuService: MenuService,
    private dialogService: DialogService
  ) {
    this.logado = this.usuarioEstaLogado();
    if (this.logado) {

      setTimeout(() => {
        this.pedidoService.getPedidos();
      }, 1000)
      this.router.navigate(["/"]);
    }
  }

  fazerLogin(usuario: { Codigo: string; Email: string; Senha: string }) {
    this.apiService
      .autenticarUsuario(usuario.Codigo, usuario.Email, usuario.Senha)
      .subscribe((dados) => {
        if (dados.status === "success") {
          this.apiService.token = dados.data.Token;
          this.usuario = dados.data;
          this.menuService.urlApp = this.usuario.UrlApp;
          this.menuService.urlLoja = this.usuario.UrlLoja;
          this.pedidoService.orders = dados.data.Pedidos;
          this.pedidoService.pedidosSubject.next(dados.data.Pedidos);
          this.pedidoService.ultimoPedido = dados.data.UltimoPedido ?? null;
          this.pedidoService.quantidadePedidos = dados.data.Quantidade;
          this.appService.statusAbertura = dados.data.StatusAbertura ?? null;
          this.appService.tempoEntrega = dados.data.TempoEntrega ?? 0;
          this.appService.inputTempoEntrega = dados.data.TempoEntrega ?? 0;
          this.appService.configuracaoMonitor = dados.data.ConfiguracaoMonitor;
          this.pedidoService.mapearKanban();
          this.salvarLocalStorage(usuario.Codigo);

          this.atividadeUsuarioService.registrar();
          this.logado = true;
          this.router.navigate(["/"]);
          this.menuService.menuAtivo = NavItemsId.HOME;
          this.snackbarService.Success(`Bem-vindo, ${dados.data.Nome}.`);
        } else {
          this.logado = false;
          this.snackbarService.Error(dados.data);
        }
      });
  }

  usuarioEstaLogado() {
    this.getLocalStorage();
    if (!this.logado) {
      return false;
    } else {
      const horaUltimaAtividade = localStorage.getItem("Update") ?? null;
      const horaAtual = Date.now();

      if (
        !horaUltimaAtividade ||
        horaAtual - Number(horaUltimaAtividade) > 14400000
      ) {
        return false;
      }
      return true;
    }
  }

  logOff() {
    this.dialogService
      .confirm("Confirmação", "Deseja realmente sair.")
      .then(() => {
        this.logado = false;
        localStorage.removeItem("Dados");
      })
      .catch((error) => { });
  }

  trocarSenha(Senha: string, NovaSenha: string) {
    return this.apiService.trocarSenha(Senha, NovaSenha).subscribe((dados) => {
      if (dados.status === "success") {
        this.snackbarService.Success(dados.data);
        this.appService.modalAlterarSenha.close();
      } else {
        this.snackbarService.Error(dados.data);
      }
    });
  }

  salvarLocalStorage(CodigoLoja: string) {
    const dados = {
      ...this.usuario,
    };
    delete dados.Pedidos;
    delete dados.UltimoPedido;
    delete dados.Quantidade;
    localStorage.setItem("Dados", JSON.stringify(dados));
    localStorage.setItem("CodigoLoja", CodigoLoja);
  }

  getLocalStorage() {
    let dados: any = localStorage.getItem("Dados") ?? null;
    if (dados) {
      dados = JSON.parse(dados) as DadosAutenticacao;
      if (!!dados.Token) {
        this.apiService.token = dados.Token;
        this.usuario = dados;
        this.appService.configuracaoMonitor = dados.ConfiguracaoMonitor;
        this.menuService.urlApp = dados.UrlApp;
        this.menuService.urlLoja = dados.UrlLoja;
        this.logado = true;
      }
    }
  }
}
